import './MGModalitySubscription.css'
import MGModalityCardSubscription from './MGModalityCardSubscription';


export default function MGModalitySubscriptionList({ subscriptionList }) {
    console.log(subscriptionList);
    return (
        <div className='MGModalitySubscriptionList-card-list'>
            {subscriptionList.map((item) => (
                <MGModalityCardSubscription
                    title={item.title}
                    imgUrl={item.images[0].url}
                    bullets={item.bullets} />
            ))}
        </div>
    );
}